<template>
	<article class="resource resource-bot">
		<PageTitleComponent v-embed-hide>{{ resource.post_title }} | Bot</PageTitleComponent>
		<div class="pad-vert">
			<div
				class="content"
				v-html="resource.post_content"
			></div>
			<div>
				<LoadingComponent
					:loading="loading"
					:outer-border="true"
				/>
				<RisposeComponent
					:agent-id="resource.rispose_agent_id"
					@loaded="loading = false"
				></RisposeComponent>
			</div>
			<p class="privacy">
				<small
					>Worried about your data? Read our
					<a
						href="https://realschools.com.au/ai-data-policy/"
						target="_blank"
						>AI data policy</a
					>.</small
				>
			</p>
		</div>
	</article>
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue';
import PageTitleComponent from '@/components/shared/PageTitleComponent.vue';
import LoadingComponent from '@/components/shared/LoadingComponent.vue';
import type { Resource } from '@/interfaces/resourceInterface';
import RisposeComponent from '@/components/RisposeComponent.vue';

/**
 * Note that some of these bots are embedded publicly into realschools.com.au pages.
 * They are public and accessible because any resource with a direct link to it can be accessed without logging in.
 */
export default defineComponent({
	components: { PageTitleComponent, LoadingComponent, RisposeComponent },
	props: {
		resource: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
	data() {
		return {
			loading: true,
		};
	},
});
</script>

<style scoped>
.content {
	margin-bottom: 40px;
	max-width: 800px;
}

.privacy {
	margin-top: 1rem;
}
</style>
